import React from 'react';
import styled from 'styled-components';

const AppWrapper = styled.div`
  margin: 0;
  display: flex;
  min-height: 100%;
  flex-direction: column;
  height: 100%;
  position: relative;

  ${(props) => props.showBannerNotification && `
    margin-top: ${props.bannerHeight}px;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  `};
`;

export const Loader = () => (
  <div className='lds-ring'>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
);

export default AppWrapper;
